module.exports = __webpack_public_path__ + "img/jidian_cop.7337a368.png";